export default {
    bulk_tags_title: "Assign Bulk Tags",
    bulk_tags_label: "Tags",
    bulk_tags_input: "IMEI or Serial",
    bulk_tags_imei: "IMEI",
    bulk_tags_serial: "Serial",
    bulk_tags_model: "Model",
    bulk_tags_assign: "Assign",
    bulk_tags_device_is_already_added: "The device is already added",
    bulk_tags_device_has_not_been_found: "The device has not been found",
    bulk_tags_multiple_success_message: "The tags were successfully assigned to the entities",
    bulk_tags_error_message: "Unable to assign the tags due to an error",
    bulk_tags_company_name: "Name",
    bulk_tags_input_company_name: "Account Name",
    bulk_tags_company_is_already_added: "The account is already added",
    bulk_tags_company_has_not_been_found: "The account has not been found",
    bulk_tags_unassign: "Unassign",
}

